import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

interface WrapperProps {
  imageSrc?: string;
}

export const BackgroundWrapper = styled.div<WrapperProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.module};
  background-image: url(\"${({ imageSrc }) => imageSrc}\");
`;

interface FormWrapperProps {
  flat?: boolean;
  isBackButton?: boolean;
  isMobileView?: boolean;
}
export const FormWrapper = styled.div<FormWrapperProps>`
  display: flex;
  width: auto;
  max-width: ${({ isBackButton, isMobileView }) => (isMobileView ? 'auto' : isBackButton ? '548' : '566')}px;
  width: ${({ isBackButton, isMobileView }) => (isMobileView ? 'auto' : isBackButton ? '548' : '566')}px;
  box-sizing: border-box;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.canvas};
  border-radius: ${({ theme }) => theme.rounds.moduleRound};
  ${({ theme }) => ({
    ...theme.shadows.default,
  })};
  padding: ${({ theme, isMobileView }) =>
    isMobileView
      ? `${theme.spacings.spacing32} ${theme.spacings.spacing24}`
      : `${theme.spacings.spacing48} ${theme.spacings.spacing72}`};
  position: relative;

  ${({ flat, theme }) => {
    if (flat) {
      return {
        padding: theme.spacings.spacing24,
      };
    }
    return {};
  }}
`;

interface BackButtonWrapperProps {
  isMobileView?: boolean;
}
export const BackButtonWrapper = styled(Box)<BackButtonWrapperProps>`
  position: absolute;
  ${({ isMobileView }) => {
    if (isMobileView) {
      return css`
        top: -64px;
        left: 0px;
      `;
    }
    return css`
      left: -50px;
    `;
  }}
`;
